import axios from 'axios'

const customInstance = axios.create ({
  baseURL : 'https://services.visaero.com'
})

export default customInstance;
